module.exports = __webpack_public_path__ + "img/solution-hudxil-system-pic-2.f4fccd39.png";